import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { AuthService } from '../auth-service';
import { Router } from '@angular/router';
import { TokenRequest } from '../../shared/models/tokenrequest.model';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
    username: string;
    password: string;
    tokenRequest: TokenRequest;
    constructor(private _userService: UserService,
        private _authService: AuthService,
        private _router: Router) {
        if (this._authService.isAdminUser) {
            this._router.navigate(['']);
        }
    }
    SiginIn() {
        this.tokenRequest = new TokenRequest(this.username, this.password);
        this._authService.signIn(this.tokenRequest);
    }
    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// ./src/opc/auth/signin/signin.component.ts